export const PROFILE_LINK_ANCHOR = 'pulsify-profile'
